import {
  CLEAN_STATE,
  FETCH_MENU_OPTIONS,
  FETCH_MENU_OPTIONS_FAILED,
  FETCH_MENU_OPTIONS_SUCCESS,
  STRUCTURE_OPTION_CHECKED,
  STRUCTURE_OPTION_CLEAR,
} from '@Pages/RetroSynthesis/StructureOption/constants';

export const initialState = {
  optionType: undefined,
  targetRect: undefined,
  data: undefined,
  synthesisMenuOptions: [],
  synthesisMenuOptionsError: undefined,
  trackingContext: undefined,
  routeType: undefined,
};

export default function reducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case STRUCTURE_OPTION_CHECKED: {
      const { targetRect, data, type, trackingContext, routeType } = payload;
      return { ...state, optionType: type, targetRect, data, trackingContext, routeType };
    }
    case FETCH_MENU_OPTIONS:
      return { ...state, synthesisMenuOptionsError: undefined };
    case FETCH_MENU_OPTIONS_SUCCESS:
      return { ...state, synthesisMenuOptionsError: undefined, synthesisMenuOptions: action.payload };
    case FETCH_MENU_OPTIONS_FAILED:
      return { ...state, synthesisMenuOptionsError: action.payload, synthesisMenuOptions: undefined };
    case STRUCTURE_OPTION_CLEAR:
      return { ...state, optionType: undefined, targetRect: undefined, data: undefined, trackingContext: undefined, routeType: undefined };
    case CLEAN_STATE:
      return { ...initialState };
    default:
      return state;
  }
}
